
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_967_967)"}},[_c('path',{attrs:{"d":"M3.9987 12.0007H2.66536C2.31174 12.0007 1.9726 11.8602 1.72256 11.6101C1.47251 11.3601 1.33203 11.0209 1.33203 10.6673V7.33398C1.33203 6.98036 1.47251 6.64122 1.72256 6.39118C1.9726 6.14113 2.31174 6.00065 2.66536 6.00065H13.332C13.6857 6.00065 14.0248 6.14113 14.2748 6.39118C14.5249 6.64122 14.6654 6.98036 14.6654 7.33398V10.6673C14.6654 11.0209 14.5249 11.3601 14.2748 11.6101C14.0248 11.8602 13.6857 12.0007 13.332 12.0007H11.9987M3.9987 6.00065V2.00065C3.9987 1.82384 4.06894 1.65427 4.19396 1.52925C4.31898 1.40422 4.48855 1.33398 4.66536 1.33398H11.332C11.5088 1.33398 11.6784 1.40422 11.8034 1.52925C11.9285 1.65427 11.9987 1.82384 11.9987 2.00065V6.00065M4.66536 9.33398H11.332C11.7002 9.33398 11.9987 9.63246 11.9987 10.0007V14.0007C11.9987 14.3688 11.7002 14.6673 11.332 14.6673H4.66536C4.29717 14.6673 3.9987 14.3688 3.9987 14.0007V10.0007C3.9987 9.63246 4.29717 9.33398 4.66536 9.33398Z","stroke":"currentColor","stroke-width":"1.33","stroke-linecap":"round","stroke-linejoin":"round"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_967_967"}},[_c('rect',{attrs:{"width":"16","height":"16","fill":"white"}})])])])
          )
        }
      }
    